import { render, staticRenderFns } from "./PDF-History-Detail.vue?vue&type=template&id=da1aeddc"
import script from "./PDF-History-Detail.vue?vue&type=script&lang=js"
export * from "./PDF-History-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports